/**
* @Description 表盘
* @Author 
* @Time 
**/

/* HTML */
<template>
	<!-- 扫码 盒子 start -->
	<div class="scan-code-box">
		
		<el-form label-width="130px" ref="rowForm" :model="rowForm">
			
			<el-form-item class="row-items-1" label="请刷卡或扫码：" prop="scode">
				<el-input ref="scodeInp" @keyup.native="scodeKeyup" @blur="scodeInpFocus" v-model="rowForm.scode" clearable/>
			</el-form-item>
			<el-form-item v-show="false" class="row-items-1" label="" prop="">
				<el-input v-model="rowForm.scode" clearable/>
			</el-form-item>
			<el-form-item class="row-items-1 btn-form-item-c">
				<a v-if="scanFilter.skipScanFlag" href="javascript:void(0);" class="scan-skip-btn" @click="skipScan">跳过刷卡或扫码</a>
				<el-button v-if="false" type="primary" size="primary" ></el-button>
			</el-form-item>
		</el-form>
		
	</div>
	<!-- 扫码 盒子 end -->
</template>

/* JS */
<script>

	export default {
		/** 
		 * @Des 组件名 
		 * @Auth 
		 * @Date
		 */
		name: "ScanCode",
		
		/**
		 * @Des 接收数据
		 * @Auth
		 * @Date
		 */
        props:{
			/**
			 * @Des 表单数据
			 * @Auth
			 * @Date
			 */
            scanFilter: {
            	type: Object,
            	default: function () {
            		return {
            			// 是否展示 跳过
            			skipScanFlag: false,
            		};// 默认表单数据
            	}
            },
            /**
			 * @Des 交互
			 * @Auth
			 * @Date
			 */
            requestFlag: {
            	type: Boolean,
            	default: function () {
            		return false;// 默认禁止交互
            	}
            },
        },// props
        
        /** 
         * @Des 数据
         * @Auth  
         * @Date 
         */
        data() {
        	return {
				// 扫码数据
        		scode: null,
        		/**
                 * @Des 修改表单
                 * @Auth
                 * @Date 2021/6/19
                 */
                rowForm: {
                	// 扫码数据
                	scode: '',
                },
                // 重置 记录当前值
                timer_scode_reset: null,
        	}// return
        },// data
		
		/** 
         * @Des 结构加载完成后自动执行
         * @Auth  
         * @Date 
         */
        created() {
			
        },// created
        
        /** 
         * @Des doc加载完成后自动执行
         * @Auth  
         * @Date 
         */
        mounted() {
        	// 输入框 获取焦点
        	this.scodeInpFocus();
			
        },// mounted
        /** 
         * @Des 销毁之前自动执行
         * @Auth  
         * @Date 
         */
		beforeDestroy() {
			
		},// beforeDestroy
		/**
         * @Des 方法注册 
         * @Auth  
         * @Date 
         */
        methods: {
        	/**
        	 * @Des 跳过扫码
        	 * @Auth
        	 * @Date
        	 */
        	skipScan() {
        		this.$emit('skipScan');
        	},
        	/**
        	 * @Des 输入框 获取焦点
        	 * @Auth
        	 * @Date
        	 */
        	// 输入框 获取焦点
        	scodeInpFocus() {
        		// 获取焦点
        		this.$refs.scodeInp.$refs.input.focus();
        	},
        	/**
        	 * @Des 输入框 键盘弹起
        	 * @Auth
        	 * @Date
        	 */
        	scodeKeyup(e) {
				// 清除计时器
				if (!this.$checkEmpty(this.timer_scode_reset)) {
					clearTimeout(this.timer_scode_reset);
					// 重置 记录当前值
					this.timer_scode_reset = null;
				}
        		
        		let nextCode,nextTime = '';
				let lastTime = this.lastTime;
				let code = this.code ? this.code : '';
				//console.log(code);
			    if (window.event) {// IE
			        nextCode = e.keyCode
			    } else if (e.which) {// Netscape/Firefox/Opera
			        nextCode = e.which
			    }
			    nextTime = new Date().getTime();
			    //字母上方 数字键0-9 对应键码值 48-57; 数字键盘 数字键0-9 对应键码值 96-105
			    
			    if((nextCode >= 48 && nextCode <= 57)  || (nextCode >= 96 && nextCode <= 105) || (nextCode >= 65 && nextCode <= 90)){
			    	
			    	let codes = {
						// 0 - 9
						'48': 48,'49': 49,'50': 50,'51': 51,'52': 52,'53': 53,'54': 54,'55': 55,'56': 56,'57': 57,
						'96': 48,'97': 49,'98': 50,'99': 51,'100': 52,'101': 53,'102': 54,'103': 55,'104': 56,'105': 57,
						// A - Z
						'65': 65,'66': 66,'67': 67,'68': 68,'69': 69,'70': 70,'71': 71,'72': 72,'73': 73,'74': 74,
						'75': 75,'76': 76,'77': 77,'78': 78,'79': 79,'80': 80,'81': 81,'82': 82,'83': 83,'84': 84,
						'85': 85,'86': 86,'87': 87,'88': 88,'89': 89,'90': 90
					};
					
					nextCode = codes[nextCode];
					nextTime = new Date().getTime();
					
			    } else {
			    	nextCode = false;
			    }
			    
			    
			    var _code = nextCode ? String.fromCharCode(nextCode) : '';
			    // 第二次输入延迟两秒，删除之前的数据重新计算
			    if(nextTime && lastTime && nextTime-lastTime>2000){
					code = _code;
			    }else{
			    	code += _code;
			    }
			    // 保存数据
			    this.nextCode = nextCode;
			    this.lastTime = nextTime;
			    if (code.length >= 16) {
			    	code = code.substring(code.length - 16)
			    }
			    this.code = code;
				// 键入Enter
			    if(e.which == 13 || code.length >= 16) {
			        // 判断 code 长度（这里就获取到条码值了，以下业务自由发挥）
			       	code = code.toUpperCase();
			        
			        if (code.length == 16) {
			            // 扫码完成
			            console.log('标签UID： ' + code);
		            	if (this.scode != code) {
		            		this.rowForm.scode = code;
				            // 回调
				            this.$emit('callback', this.code);
				            // 记录当前值
				            this.scode = code;
		            	}
			        } else if (this.rowForm.scode.length >= 16) {
			        	console.log('未知码： ' + code);
			        	
			        	let scode = this.rowForm.scode;
			        	scode = this.rowForm.scode.substring(this.rowForm.scode.length - 16);
			        	
			        	if (this.scode != scode) {
			        		this.rowForm.scode = scode;
				        	// 回调
				            this.$emit('callback', this.rowForm.scode);
				            // 记录当前值
				            this.scode = scode;
			        	}
			        }
			        
					// 重置 记录当前值
					this.timer_scode_reset = setTimeout(() => {
						// 记录当前值
						this.scode = null;
					}, 2000);
					
			        //键入回车务必清空code值
			    	this.code = ''
			    	return false;
			    }
        	},
        	
        },// methods
		
        /** 
         * @Des 方法注册 
         * @Auth  
         * @Date 
         */
        watch: {
        	
        },// watch
        
    }// export default
</script>

/* CSS */
<style lang="scss" scoped src="./style-scan-code.scss"></style>


// WEBPACK FOOTER //
// src/components/ScanCode/ScanCode.vue